module.exports = __webpack_public_path__ + "img/crown.baa1c5a7.svg";